module.exports = __webpack_public_path__ + "img/06.9a5ed5a0.png";